<template>
    <div class="relative bg-wrap-color">
        <template v-if="isPageAllowed">
            <div style="transition: none;" v-show="componentName != 'CreatePage'">
                <div class="tab-bar relative">
                    <el-tabs v-model="activeTabName" @tab-click="changeTab">
                        <el-tab-pane label="素材管理" name="intelligent_managed_rule"></el-tab-pane>
                    </el-tabs>
                </div>
            </div>

            <div class="pl10 pr10 pb10">
                <keep-alive :include="keepList">
                    <component
                        :is="componentName"
                        @create="showCreatePage"
                        @changePage="handleChangePage"
                        @close="handleCreateClose"
                        :query="query"
                        :reload="reload"
                        :data="actionData"
                        :type="actionType"
                        :pageFuncNames="tabFuncNames"
                    />
                </keep-alive>

            </div>
        </template>
        <template v-else>
            <NoPermissionInfo>
                <p>素材库</p>
            </NoPermissionInfo>
        </template>
    </div>
</template>


<script>
import StorePage from './pages/store/index.vue'
import NoPermissionInfo from "@/components/noPermissionInfo.vue";
import {pageMixin} from '../../mixins/pageMixin';
export default {
    name: 'store',
    mixins: [pageMixin],
    components: {
        NoPermissionInfo,
        StorePage
    },
    data() {
        return {
            create_show: true,  //创建页面
            activeTabName:'intelligent_managed_rule',
            componentName: 'StorePage',
            keepList:['StorePage'],
            query: {}, //传入对象
            reload: '', //更新接口
            actionData:{},
            actionType:'',
        }
    },
    computed:{
        tabFunc(){
            let actionTab = (this.pageAction||[]).find(item=> item.name === 'material_list');
            if(actionTab){
                return actionTab.func||[];
            }
            return [];
        },
        tabFuncNames(){
            return (this.tabFunc||[]).map(item=>item.name);
        },
    },
    created() {
        // 由列队页面跳转任务管理-工单想请你
        // if(this.$route.query.topage === 'StorePage') {
        //     //material_type 数组 1:图片 2:视频
        //     this.handleChangePage(this.$route.query.topage, {material_type:'', project_id: 3})
        // }
    },
    methods:{
        showCreatePage(){
            // this.create_show = true;
        },
        changeTab(tab){
            // this.query = {}
            // if(this.activeTabName == 'intelligent_managed_rule') {
            //     this.componentName = 'RulePage'
            //     this.keepList = ['RulePage']
            // }else if(this.activeTabName == 'intelligent_managed_run_record') {
            //     this.componentName = 'RunRecordPage'
            //     this.keepList = [];
            // }else if(this.activeTabName == 'intelligent_managed_trigger_record') {
            //     this.componentName = 'TriggerRecordPage'
            //     this.keepList = [];
            // }
        },
        handleCreateClose(){
            this.create_show = false;
        },
        handleChangePage(url, params,type) {
            if(url ==='StorePage'){
                this.componentName = url;
                this.query = params
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.tab-bar::after{
    content: '';
    position: absolute;
    left: -20px;
    right: -20px;
    background-color: #fff;
}
.tab-bar ::v-deep .el-tabs__header{
    background-color: #fff;
    margin-bottom: 10px;
    .el-tabs__nav-wrap{
        padding-left: 30px;
    }
}
.tab-bar ::v-deep .el-tab-pane{
    margin: 0 15px;
}
.bg-wrap-color{
    padding: 0;
    background-color:#F1F4F9;
}
</style>
